import { Calculator } from "lucide-react";
import { useCorPricing } from "@/hooks/useCorPricing";
import { CorPricingRow } from "./cor/CorPricingRow";

const money = (v) => (v === null || v === undefined ? "TBD" : `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
const netTotal = (co) => (co.totals.priced_items || co.credits.some((c) => c.amount !== null) ? money(co.totals.amount_net) : "TBD");

export function CorPricing({ runId, canEdit }) {
  const { co, val, edit, save } = useCorPricing(runId);
  if (!co) return null;
  const all = [...co.items, ...co.credits.map((c) => ({ ...c, credit: true }))];
  const t = co.totals;
  return (
    <div className="sc-card p-6 mb-4 border-emerald-500/20" data-testid="cor-pricing-card">
      <div className="flex items-start justify-between gap-3 flex-wrap mb-3">
        <div>
          <div className="label-cap flex items-center gap-1.5"><Calculator className="w-3.5 h-3.5 text-emerald-400" /> Change Order pricing — {co.ref}</div>
          <p className="text-xs text-slate-500 mt-1">Enter a dollar amount and calendar days per change item; the Change Order Request letter carries these totals. Leave blank for "to be priced". Credits are entered as positive amounts.</p>
        </div>
        <div className="text-right">
          <div className="label-cap">Net request</div>
          <div className="font-heading text-2xl font-extrabold text-emerald-400" data-testid="cor-net-total">{netTotal(co)}</div>
          <div className="text-[11px] font-mono text-slate-500">{money(t.amount_additions)} adds · {money(t.amount_credits)} credits · {t.days || 0} days · {t.unpriced_items} unpriced</div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="sc-table w-full text-xs">
          <thead><tr><th>#</th><th>Change item</th><th>Quantities</th><th className="text-right">Amount ($)</th><th className="text-right">Days</th><th>Estimator note</th></tr></thead>
          <tbody>{all.map((it) => <CorPricingRow key={it.finding_id} it={it} canEdit={canEdit} val={val} edit={edit} save={save} />)}</tbody>
        </table>
      </div>
      <p className="text-xs text-slate-300 mt-3 italic" data-testid="cor-pricing-statement">{co.pricing_statement} {co.schedule_request}</p>
    </div>
  );
}
